import { createFileRoute, redirect } from '@tanstack/react-router';

import { ROUTES } from '@/constants/routes';

export const Route = createFileRoute('/admin/_app/platform-settings/')({
  beforeLoad: () => {
    throw redirect({ to: ROUTES.reportPricing });
  },
});
